import i18n from '~/translations';

export const CUSTOM_ERROR_MESSAGE = {
  teamsIntegrationAlreadyExists: i18n.t(
    'integrationProcess.teams.config.project.alreadyConnected',
    'This project is already connected to the channel.',
  ),
};
